"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.dashboards")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.dashboards", {
            url: "/dashboard/:dashboardId",
            params: {
                dashboardId: { value: null, dynamic: true }
            }
        })
        .state("nucont.accounting.company.dashboards.view", {
            url:
                "/:period/:date?source&startDate&comparationDate&comparationPeriod&otherPeriod&scenario&scenarioCompare&startTour&comparationActive&allMonths&projection&budget&goals",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-dashboards" */ "./dashboards.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.dashboards")
                );
            },
            params: {
                comparationDate: { value: null, dynamic: true },
                source: { value: null, dynamic: true },
                comparationPeriod: { value: null, dynamic: true },
                otherPeriod: { value: null, dynamic: true },
                startDate: { value: null, dynamic: true },
                date: { value: null, dynamic: true },
                period: { value: null, dynamic: true },
                scenario: { value: null, dynamic: true },
                scenarioCompare: { value: null, dynamic: true },
                startTour: { value: null, dynamic: true },
                comparationActive: { value: null, dynamic: true },
                allMonths: { value: null, dynamic: true },
                projection: { value: null, dynamic: true },
                budget: { value: null, dynamic: true },
                goals: { value: null, dynamic: true }
            },
            views: {
                "admin@nucont.accounting": {
                    bindings: { companyData: "CompanyData" },
                    component: "dashboardsComponent"
                }
            }
        });
}
